import { ExtrudeGeometry, Mesh, Shape } from "three";
import { Jaco } from "oc-jaco3d/arrangement/Jaco";
import { Jaco3d } from "oc-jaco3d/arrangement3d/Jaco3d";
import { v3 } from "oc-threejs/short3";
import * as Scenes from "oc-threejs/Scenes";
import { Fundament } from "../arrangement/Fundament";

export class Fundament3d extends Jaco3d {
  CLASS_NAME = "Fundament3d";
  mesh: Mesh;
  declare jaco: Fundament;

  constructor(jaco: Jaco) {
    super(jaco);
  }

  update3d() {
    super.update3d();
    if (this.changed("tiefe") || this.changed("points")) {
      Scenes.remove(this.mesh);
      const material = APP.materials.create("Beton");
      if (APP.isTorkonfigurator && (material as any).transparent) {
        (material as any).depthWrite = false;
      }
      const s = new Shape();
      const fundament = this.jaco;
      const ps = fundament.points;
      s.moveTo(ps[0].x, ps[0].y);
      for (let i = 1; i < ps.length; i++) {
        s.lineTo(ps[i].x, ps[i].y);
      }
      s.closePath();
      const geometry = new ExtrudeGeometry(s, {
        depth: fundament.tiefe,
        bevelEnabled: false,
      });
      geometry.lookAt(v3(0, -1, 0));
      geometry.translate(0, this.jaco.bodenAbstand, 0);
      this.mesh = new Mesh(geometry, material);
      this.add(this.mesh);
    }
  }

  clone(recursive?: boolean) {
    return new Fundament3d(this.jaco) as this;
  }

  getBox() {
    return this.jaco.getBox();
  }
}
